import {createFileRoute} from '@tanstack/react-router';

import SessionsView from '../../../sessions/SessionsView.tsx';

export const Route = createFileRoute('/_app/sessions/')({
    component: RouteComponent,
});

function RouteComponent() {
    return <SessionsView />;
}
